export interface UsageEntry {
  date: string;
  total_rows: number;
  number_of_steps: number;
}
export interface WorkflowBreakdownEntry {
  date: string;
  [workflowName: string]: number | string;
}

export interface WorkflowBreakdownResponse {
  number_of_steps: WorkflowBreakdownEntry[];
  total_rows: WorkflowBreakdownEntry[];
}

export type MonthOption = {
  key: string;
  label: string;
  year: number;
  monthIdx: number;
};

export const TZ = 'America/Los_Angeles';
